import PropTypes from "prop-types";
import Tooltip from "@shared/v2/Tooltip";
import Toggle from "@shared/v2/Toggle";
import { CircleInfoSolidV6, HeartRegularV6 } from "@shared/v2/Icomoon";
import { alertDefaultProps, alertPropTypes, truncateText } from "./helper";

const CollectionCard = ({
  alert,
  index,
  customClassName,
  websiteUrl,
  onToggleNotification,
  doesLeadHaveApp,
}) => (
  <div
    key={alert.alertId}
    className={`tw-shadow-card tw-rounded-[6px] tw-p-[16px] tw-flex tw-flex-col ${customClassName}`}
  >
    <div className="tw-flex tw-justify-between tw-gap-[4px]">
      <div className="tw-flex tw-text-wrap [word-break:break-word]">
        <div className="tw-flex tw-items-center">
          <HeartRegularV6 size="m" />
        </div>
        <a
          href={`https://${websiteUrl}/${alert.searchUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="tw-flex tw-items-center tw-pl-[8px] tw-font-semibold !tw-text-[14px] tw-text-gray-75 tw-cursor-pointer"
        >
          {truncateText(alert.searchName, 55)}
        </a>
      </div>
    </div>

    <div className="tw-pt-[12px]">
      <span className="tw-text-[12px] tw-text-gray-50 tw-font-semibold">Collection</span>
    </div>
    <div className="tw-pt-[12px]">
      <Toggle
        value={
          doesLeadHaveApp ? alert.activeForAppNotifications && alert.activeForEmails : alert.activeForEmails
        }
        checked={
          doesLeadHaveApp ? alert.activeForAppNotifications && alert.activeForEmails : alert.activeForEmails
        }
        trackClassName="!tw-w-[28px] !tw-h-[16px]"
        dotClassName="!tw-w-[12px] !tw-h-[12px] !tw-left-[2px]"
        onChange={(e) => onToggleNotification(index, e.target.checked)}
        labelClassName="tw-text-[12px] !tw-text-gray-75 tw-font-semibold !tw-gap-[6px]"
        text={
          <>
            Send property notifications
            <Tooltip
              trigger={<CircleInfoSolidV6 size="m" className="tw-text-gray-75 tw-ml-[6px] tw-align-middle" />}
              innerClassName="!tw-text-left tw-max-w-[180px]"
              content="When enabled, this contact will receive an email and Brivity Home notification (if applicable) when any property in the collection changes in price or comes back on the market"
              placement="top"
            />
          </>
        }
      />
    </div>
  </div>
);

CollectionCard.propTypes = {
  alert: alertPropTypes,
  customClassName: PropTypes.string,
  index: PropTypes.number.isRequired,
  websiteUrl: PropTypes.string,
  onToggleNotification: PropTypes.func,
  doesLeadHaveApp: PropTypes.bool,
};
CollectionCard.defaultProps = {
  alert: alertDefaultProps,
  customClassName: "",
  websiteUrl: "",
  onToggleNotification: null,
  doesLeadHaveApp: false,
};

export default CollectionCard;
